<app-header
    [clicked]="clickedOutside"
    (changeMegaMenuCondition)="changeMenuCondition($event)"
    (selectedLanguage)="switchLanguageHandler($event)"
></app-header>
<div class="tw-relative" (click)="closeMegaMenuCondition()">
    <div class="tw-hidden md:tw-block">
        <div
            *ngIf="bannerData?.length == 0"
            class="tw-relative tw-w-full tw-min-h-[490px] tw-h-[571px] md:tw-min-h-[33vh] lg:tw-min-h-[33vh] xl:tw-min-h-[81vh] tw-overflow-hidden"
            alt="palceholder"
        ></div>
        <ngx-slick-carousel
            *ngIf="bannerData.length > 0"
            class="carousel"
            #slickModal="slick-carousel"
            [config]="slideConfig"
            (afterChange)="afterChange($event)"
            (beforeChange)="beforeChange($event)"
        >
            <div ngxSlickItem *ngFor="let slide of bannerData" class="">
                <div
                    class="tw-relative tw-w-full tw-aspect-[16/6] tw-overflow-hidden"
                >
                    <img
                        [attr.ga-event-id]="
                            slide?.campaigndetails?.campaignName +
                            '_main_banner_button_homepage_click'
                        "
                        ga-event-category="Homepage Button"
                        [attr.ga-event-label]="
                            slide?.campaigndetails?.campaignName +
                            ' Main Banner Main Button Click'
                        "
                        ga-track="track"
                        [ngClass]="
                            slide.id != 0
                                ? 'tw-cursor-pointer'
                                : 'tw-cursor-default'
                        "
                        class="tw-w-full tw-h-full tw-object-cover tw-z-[1] tw-absolute tw-left-0 tw-top-0"
                        [src]="slide?.campaigndetails?.bannerImageUrlArray?.[0]"
                        alt="Home slides"
                        (click)="onClickImageRoute(slide.campaignUrl)"
                    />
                </div>
            </div>
        </ngx-slick-carousel>
    </div>
    <div class="tw-block md:tw-hidden">
        <div
            *ngIf="bannerData?.length == 0"
            class="tw-relative tw-block md:tw-hidden tw-min-h-[550px]"
            alt="palceholder"
        ></div>
        <ngx-slick-carousel
            class="carousel"
            #slickModal="slick-carousel"
            [config]="slideConfig"
            (afterChange)="afterChange($event)"
            (beforeChange)="beforeChange($event)"
        >
            <div ngxSlickItem *ngFor="let slide of bannerData">
                <div
                    class="tw-min-h-[551px] md:tw-min-h-auto md:tw-max-h-auto tw-max-h-[551px] tw-h-auto sm:tw-h-[70vh] tw-rounded-2xl- tw-overflow-hidden"
                    [ngClass]="
                        slide.id == 1
                            ? 'tw-cursor-pointer'
                            : 'tw-cursor-default'
                    "
                    (click)="onClickImageRoute(slide.campaignUrl)"
                >
                    <img
                        [attr.ga-event-id]="
                            slide?.campaigndetails?.campaignName +
                            '_main_banner_button_homepage_click'
                        "
                        ga-event-category="Homepage Button"
                        [attr.ga-event-label]="
                            slide?.campaigndetails?.campaignName +
                            ' Main Banner Main Button Click'
                        "
                        ga-track="track"
                        class="tw-cursor-pointer tw-min-h-[551px] md:tw-min-h-auto md:tw-max-h-auto tw-max-h-[551px] tw-w-full"
                        [src]="
                            slide?.campaigndetails
                                ?.bannerMobileImageUrlArray?.[0]
                                ? slide?.campaigndetails
                                      ?.bannerMobileImageUrlArray?.[0]
                                : slide?.campaigndetails
                                      ?.bannerImageUrlArray?.[0]
                        "
                        alt="Mobile Banner Slide"
                    />
                </div>
            </div>
        </ngx-slick-carousel>
    </div>

    <div class="" (click)="closeMegaMenuCondition()">
        <app-home-benefits></app-home-benefits>
        <app-home-services></app-home-services>
        <app-home-features></app-home-features>
        <app-home-whats-new
            [whatsNewData]="whatsNewData"
            (whatsNewDetailsClick)="viewWhatsNewDetails($event)"
        ></app-home-whats-new>
    </div>

    <app-footer
        (click)="closeMegaMenuCondition()"
        [selectedLanguage]="languageSelected"
    ></app-footer>
</div>
